import React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
    
      <div className="slide-container">
        <div>
          <img
            src="https://www.sephora.com/contentimages/2023-fragrance-q2-site-home-page-rwd-hero-banner-US-2973-image-only-1000x750.jpg?imwidth=545"
            alt=""
          />
          <div className="slide-text-box">
            <h3>CHANEL Fragrances</h3>
            <h5>Discover how these bestselling scents make you feel.</h5>
            <p>SHOP NOW ⮞</p>
          </div>
        </div>
        <div>
          <img
            src="https://www.sephora.com/contentimages/2023-03-25-slotting-just-arrived-v2-standard-site-rwd-home-page-hero-banner-4-product-english-US-CA_01.jpg?imwidth=545"
            alt=""
          />
          <div className="slide-text-box">
            <h3>This Just In</h3>
            <h5>The latest beauty from the hottest brands.</h5>
            <p>SHOP NOW ⮞</p>
          </div>
        </div>
        <div>
          <img
            src="https://www.sephora.com/contentimages/2023-3-23-gxve-eye-story-site-desktop-mobile-home-page-rwd-hero-banner-1000x750-en-us-can.jpg?imwidth=545"
            alt=""
          />
          <div className="slide-text-box">
            <h3>NEW GXVE BY GWEN STEFANI</h3>
            <h5>
              Rock iconic eye looks with pigement-packed formulas that won't
              flake.
            </h5>
            <p>SHOP NOW ⮞</p>
          </div>
        </div>
        <div>
          <img
            className="weird"
            src="https://www.sephora.com/contentimages/2023-03-18-slotting-clean-site-rwd-home-page-hero-banner-4-product-english-us-ca-handoff_01.jpg?imwidth=545"
            alt=""
          />
          <div className="slide-text-box">
            <h3>Trending Clean Makeup</h3>
            <h5>Picks you'll love, minus ingredients you might not.</h5>
            <p>SHOP NOW ⮞</p>
          </div>
        </div>
        <div>
          <img
            src="https://www.sephora.com/contentimages/2023-fragrance-q1-site-home-page-hero-banner-newness-US-CAN-2833-release-1000x750-image-only.jpg?imwidth=545"
            alt=""
          />
          <div className="slide-text-box">
            <h3>Just-Dropped Scents</h3>
            <h5>Discover how fragnance make you feel.</h5>
            <p>SHOP NOW ⮞</p>
          </div>
        </div>
        <div>
          <img
            src="https://www.sephora.com/contentimages/2023-03-10-slotting-just-arrived-v4-standard-site-responsive-home-page-hero-banner-US_01.jpg?imwidth=545"
            alt=""
          />
          <div className="slide-text-box">
            <h3>The Latest Lineup</h3>
            <h5>New beauty from the hottest brands.</h5>
            <p>SHOP NOW ⮞</p>
          </div>
        </div>
      </div>
      <div className="just-dropped">
        <div className="just-dropped-text">
          <h5>Just Dropped</h5>
          <p>Show More</p>
        </div>
        <div className="dropped-products">
          <div>
            <button>NEW</button>
            <Link to="/Makeup"><div>
              <img
                src="https://www.sephora.com/productimages/sku/s2650828-main-zoom.jpg?pb=2020-03-sephora-clean-2019&imwidth=166"
                alt=""
              />
            </div></Link>
            <div>
              <h5>Tatcha</h5>
              <p>Dewy Cleanse + Hydrate Duo</p>
            </div>
          </div>
          <div>
            <button>NEW</button>
            <div>
              <img
                src="https://www.sephora.com/productimages/sku/s2672939-main-zoom.jpg?imwidth=166"
                alt=""
              />
            </div>
            <div>
              <h5>Dr. Brandt Skincare</h5>
              <p>Neck Tightening Cream</p>
            </div>
          </div>
          <div>
            <button>NEW</button>
            <div>
              <img
                src="https://www.sephora.com/productimages/sku/s2647667-main-zoom.jpg?pb=2020-03-sephora-clean-2019&imwidth=166"
                alt=""
              />
            </div>
            <div>
              <h5>NUDESTIX</h5>
              <p>Mini Pink Nude Blush 3 PC Kit</p>
            </div>
          </div>
          <div>
            <button>NEW</button>
            <div>
              <img
                src="https://www.sephora.com/productimages/sku/s2649085-main-zoom.jpg?imwidth=166"
                alt=""
              />
            </div>
            <div>
              <h5>Sol de Janeiro</h5>
              <p>Bum Bum Firmeza Fimming</p>
            </div>
          </div>
          <div>
            <button>NEW</button>
            <div>
              <img
                src="https://www.sephora.com/productimages/sku/s2638971-main-zoom.jpg?imwidth=166"
                alt=""
              />
            </div>
            <div>
              <h5>Glossier</h5>
              <p>Perfecting Skin Tint for Dewy Sheer</p>
            </div>
          </div>
        </div>
      </div>
      <div className="beauty-offers">
        <div className="beauty-offers-text">
          <h5>Beauty Offers (11)</h5>
          <p>View all</p>
        </div>
        <div className="beauty-products">
          <div>
            <div>
              <img
                src="https://www.sephora.com/contentimages/promo/bpme/2023/March/2023-3-30-bi-app-only-brand-wide-banner-new-4x-augustinus-bader.jpg?imwidth=240"
                alt=""
              />
            </div>
            <div>
              <h5>Get 4X Points††</h5>
              <h6>on ALL Augustinus Bader—only on the app.</h6>
              <p>
                Beauty Insider members only. <br />
                App only • Ends 4/5/2023 ††Exclusions/terms apply. May be
                combined with other promotional offers.
              </p>
            </div>
            <div className="bty-btn">
              <button>Download App</button>
              <p>See details</p>
            </div>
          </div>
          <div>
            <div>
              <img
                src="https://www.sephora.com/contentimages/promo/bpme/2023/March/2023-3-30-bi-app-only-brand-wide-banner-new-4x-beauty-blender.jpg?imwidth=240"
                alt=""
              />
            </div>
            <div>
              <h5>Get 4X Points††</h5>
              <h6>on ALL Augustinus Bader—only on the app.</h6>
              <p>
                Beauty Insider members only. <br />
                App only • Ends 4/5/2023 ††Exclusions/terms apply. May be
                combined with other promotional offers.
              </p>
            </div>
            <div className="bty-btn">
              <button>Download App</button>
              <p>See details</p>
            </div>
          </div>
          <div>
            <div>
              <img
                src="https://www.sephora.com/contentimages/promo/bpme/2023/March/2023-3-30-bi-brand-wide-banner-new-4x-fresh.jpg?imwidth=240"
                alt=""
              />
            </div>
            <div>
              <h5>Get 4X Points††</h5>
              <h6>Be the prime member to try first. Open App and Subscribe</h6>
              <p>
                Beauty Insider members only. <br />
                App only • Ends 4/5/2023 ††Exclusions/terms apply. May be
                combined with other promotional offers.
              </p>
            </div>
            <div className="bty-btn">
              <button>Download App</button>
              <p>See details</p>
            </div>
          </div>
          <div>
            <div>
              <img
                src="https://www.sephora.com/contentimages/promo/beautyoffers/2023/March/2023-03-31-HELLATHICC-slotting-promo-app-beauty-offers-banner-us-ca-handoff.jpg?imwidth=240"
                alt=""
              />
            </div>
            <div>
              <h5>Get 4X Points††</h5>
              <h6>Be the prime member to try first. Open App and Subscribe</h6>
              <p>
                Beauty Insider members only. <br />
                App only • Ends 4/5/2023 ††Exclusions/terms apply. May be
                combined with other promotional offers.
              </p>
            </div>
            <div className="bty-btn">
              <button>Download App</button>
              <p>See details</p>
            </div>
          </div>
          <div>
            <div>
              <img
                src="https://www.sephora.com/contentimages/promo/beautyoffers/2023/March/2023-3-22-glow-recipe-strawberry-bha-pore-smooth-blur-drops-site-desktop-mobile-app-beauty-offers-page-banner-en-us-can.jpg?imwidth=240"
                alt=""
              />
            </div>
            <div>
              <h5>Get 4X Points††</h5>
              <h6>on ALL Augustinus Bader—only on the app.</h6>
              <p>
                Beauty Insider members only. <br />
                App only • Ends 4/5/2023 ††Exclusions/terms apply. May be
                combined with other promotional offers.
              </p>
            </div>
            <div className="bty-btn">
              <button>Download App</button>
              <p>See details</p>
            </div>
          </div>
        </div>
      </div>
      <div className="skin-care">
        <div>
          <h4>Rx Skincare. Is It Time?</h4>
          <p>See what a dermatologist has to say. </p>
          <h5>LEARN MORE FROM </h5>
          <img
            src="https://www.sephora.com/contentimages/homepage/022123/Homepage/APP/Renova_Homepage%20Marketing%20Banner_800x256.jpg?imwidth=400"
            alt=""
          />
        </div>
        <div>
          <h4>Makeup Your Skin Will Love</h4>
          <p>Starting at $15</p>
          <h5>SHOP NOW</h5>
          <img
            src="https://www.sephora.com/contentimages/2023-01-27-sc-bse-site-desktop-mobile-home-page-rwd-marketing-banner-final-800x256.jpg?imwidth=400"
            alt=""
          />
        </div>
        <div>
          <h4>Paula's Choice Must-Haves</h4>
          <p>
            Visibly smooth lines in 15 minutes* with the NEW serum, or unclog
            pores with the fan-fave exfoliant.
          </p>
          <img
            src="https://www.sephora.com/contentimages/2023-3-19-paulas-choice-pro-collagen-multi-peptide-booster-site-desktop-mobile-home-page-rwd-marketing-banner-800x256-en-us.jpg?imwidth=400"
            alt=""
          />
        </div>
      </div>
      <div className="just-dropped">
        <div className="just-dropped-text">
          <h5>Selling Fast</h5>
          <p>Show More</p>
        </div>
        <div className="dropped-products">
          <div>
            <button>#1</button>
            <div>
              <img
                src="https://www.sephora.com/productimages/sku/s2590131-main-zoom.jpg?imwidth=166"
                alt=""
              />
            </div>
            <div>
              <h5>Fenty beauty by Rihanna</h5>
              <p>Blotting + Hydrate Duo</p>
            </div>
          </div>
          <div>
            <button>#2</button>
            <div>
              <img
                src="https://www.sephora.com/productimages/sku/s2655892-main-zoom.jpg?imwidth=166"
                alt=""
              />
            </div>
            <div>
              <h5>Fenty beauty by Rihanna</h5>
              <p>Neck Tightening Cream</p>
            </div>
          </div>
          <div>
            <button>#3</button>
            <div>
              <img
                src="https://www.sephora.com/productimages/sku/s2418713-main-zoom.jpg?imwidth=166"
                alt=""
              />
            </div>
            <div>
              <h5>Fenty beauty by Selena</h5>
              <p>Stay Vulnerable Liquid</p>
            </div>
          </div>
          <div>
            <button>#4</button>
            <div>
              <img
                src="https://www.sephora.com/productimages/sku/s2634673-main-zoom.jpg?imwidth=166"
                alt=""
              />
            </div>
            <div>
              <h5>Saie</h5>
              <p>Super Glowy for light skin</p>
            </div>
          </div>
          <div>
            <button>#5</button>
            <div>
              <img
                src="https://www.sephora.com/productimages/sku/s2637387-main-zoom.jpg?pb=clean-planet-positive-badge-2021&imwidth=166"
                alt=""
              />
            </div>
            <div>
              <h5>Farmacy</h5>
              <p>Brighten Up 3% TXA Dark</p>
            </div>
          </div>
        </div>
      </div>
      <div className="featured-cat">
        <div>
          <h3>Featured Categories</h3>
          <p>Shop what’s popular now.</p>
        </div>
        <div className="featured-products">
          <div>
            <p>Foundation</p>
            <img
              src="https://www.sephora.com/contentimages/homepage/060222/Homepage/RWD/CategoryTiles/homepage_featured_category_tile_samples_32_us_ca_rwd_slice.png?imwidth=53"
              alt=""
            />
          </div>
          <div>
            <p>Moisturizers</p>
            <img
              src="https://www.sephora.com/contentimages/homepage/060222/Homepage/RWD/CategoryTiles/homepage_featured_category_tile_skincare_cleanser_moisturizer_us_ca_rwd_slice.jpg?imwidth=53"
              alt=""
            />
          </div>
          <div>
            <p>Hair Treatments</p>
            <img
              src="https://www.sephora.com/contentimages/homepage/091322/Homepage/RWD/hair%20dryer.JPG?imwidth=53"
              alt=""
            />
          </div>
          <div>
            <p>Perfume</p>
            <img
              src="https://www.sephora.com/contentimages/homepage/060222/Homepage/RWD/CategoryTiles/homepage_featured_category_tile_fragrance_bottle_us_ca_rwd_slice.jpg?imwidth=53"
              alt=""
            />
          </div>
          <div>
            <p>Minis</p>
            <img
              src="https://www.sephora.com/contentimages/homepage/060222/Homepage/RWD/CategoryTiles/homepage_featured_category_tile_minis_us_ca_rwd_slice.png?imwidth=53"
              alt=""
            />
          </div>
          <div>
            <p>Sephora Collection</p>
            <img
              src="https://www.sephora.com/contentimages/homepage/060222/Homepage/RWD/CategoryTiles/homepage_featured_category_tile_sephoracollection_SC_us_ca_rwd_slice.jpg?imwidth=53"
              alt=""
            />
          </div>
          <div>
            <p>Clean Beauty</p>
            <img
              src="https://www.sephora.com/contentimages/categorybanners/RWD/icons/clean_guide.svg"
              alt=""
            />
          </div>
          <div>
            <p>Sale</p>
            <img
              src="https://www.sephora.com/contentimages/categorybanners/RWD/icons/sale%2032@3x.jpg?imwidth=53"
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="featured-cat">
        <div>
          <h3>Need a Little Guidance?</h3>
          <p>
            Check out our <span>quizzes and buying guides.</span>
          </p>
        </div>
        <div className="featured-products">
          <div>
            <p>Clinical Skincare</p>
            <img
              src="https://www.sephora.com/contentimages/categorybanners/RWD/icons/skincare_quiz.svg"
              alt=""
            />
          </div>
          <div>
            <p>Foundation Quiz</p>
            <img
              src="https://www.sephora.com/contentimages/categorybanners/RWD/icons/foundation_guide.svg"
              alt=""
            />
          </div>
          <div>
            <p>Skincare Routine</p>
            <img
              src="https://www.sephora.com/contentimages/categorybanners/RWD/icons/skincare_age.svg"
              alt=""
            />
          </div>
          <div>
            <p>Shiny Hair Guide</p>
            <img
              src="https://www.sephora.com/contentimages/homepage/060222/Homepage/RWD/CategoryTiles/homepage_featured_category_tile_healthy%20scalp%20guide_us_ca_rwd_slice.png?imwidth=53"
              alt=""
            />
          </div>
          <div>
            <p>Fragrance Hub</p>
            <img
              src="https://www.sephora.com/contentimages/categorybanners/RWD/icons/niche_fragrances.svg"
              alt=""
            />
          </div>
          <div>
            <p>Black Owned</p>
            <img
              src="https://www.sephora.com/contentimages/homepage/060222/Homepage/RWD/CategoryTiles/homepage_featured_category_tile_BOB_us_rwd_slice.png?imwidth=53"
              alt=""
            />
          </div>
          <div>
            <p>Lip Quiz</p>
            <img
              src="https://www.sephora.com/contentimages/categorybanners/RWD/icons/lip_quiz.svg"
              alt=""
            />
          </div>
          <div>
            <p>Fragrance Gift Guide</p>
            <img
              src="https://www.sephora.com/contentimages/categorybanners/RWD/icons/fragrance_quiz.svg"
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="skin-care">
        <div className="aa">
          <h4>Our Commitment to Diversity, Equity & Inclusion</h4>
          <p>See what a dermatologist has to say.</p>
          <h5>LEARN MORE</h5>
          <img
            src="https://www.sephora.com/contentimages/homepage/060222/Homepage/RWD/homepage-reassurance-banner-diversity-inclusion-desktop-mobile-us-ca-slice.jpeg?imwidth=400"
            alt=""
          />
        </div>
        <div className="bb">
          <h4>Beauty On Demand</h4>
          <p>Fast and easy options that work for you.</p>
          <h5>LEARN MORE</h5>
          <img
            src="https://www.sephora.com/contentimages/homepage/060222/Homepage/RWD/homepage-reassurance-banner-ease-convenience-desktop-mobile-us-ca-slice.jpeg?imwidth=400"
            alt=""
          />
        </div>
        <div className="cc">
          <h4>Clean + Planet Positive</h4>
          <p>Brands on a easy mission to change your skin and the earth</p>
          <h5>LEARN MORE</h5>
          <img
            src="https://www.sephora.com/contentimages/homepage/060222/Homepage/RWD/homepage-reassurance-banner-clean-planet-positive-desktop-mobile-us-ca-slice.jpeg?imwidth=400"
            alt=""
          />
        </div>
      </div>
      <div className="feedback-bar">
        <p>Website feedback? Let us know ▸</p>
      </div>
    </div>
  );
};

export default Home;
